var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-select',{attrs:{"value":_vm.value,"clearable":false},on:{"input":_vm.input}},_vm._l((_vm.$t('pbx.stat.common.filter.group_by.values')),function(item,key){return _c('i-option',{key:key,attrs:{"value":key,"label":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }